import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Parking } from '@/service'
import { useMapTracking } from '@/hooks/useMapTracking'

import {
  PriceAndButton,
  TextLink,
  TreriaryLink
} from './CustomMapButtons.styled'

export default function CustomMapButtons({ parking }: { parking: Parking }) {
  const { t } = useTranslation('parkings')
  const router = useRouter()
  const { trackMapInteraction } = useMapTracking()

  const startDate = router.query?.startDate
  const endDate = router.query?.endDate

  const translatedParkingTileDetails = t(
    'searchNearParking.parkingTile.details'
  )
  const translatedParkingTileQuickBook = t(
    'searchNearParking.parkingTile.quickBooking'
  )

  const parkings = router?.locale === 'pl' ? 'parkingi' : 'parkings'

  const handleDetailsClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    trackMapInteraction('MAP_PARKING_DETAILS', parking, {
      source: 'map_custom_buttons'
    })
  }

  const handleQuickBookClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    trackMapInteraction('MAP_PARKING_QUICK_BOOKING', parking, {
      startDate: startDate as string,
      endDate: endDate as string,
      bookType: parking?.reservationAvailable ? 'reservation' : 'subscription'
    })
  }

  return (
    <PriceAndButton
      onClick={e => e.stopPropagation()}
      data-test-id="price-and-button"
    >
      <Link
        href={{
          pathname: `/${parkings}/[city]/[slug]`,
          query: { city: parking.cityUrlSlug, slug: parking.urlSlug }
        }}
        passHref
      >
        <TextLink
          onClick={handleDetailsClick}
          data-test-id="parking-tile-details"
        >
          {translatedParkingTileDetails}
        </TextLink>
      </Link>
      <Link
        href={{
          pathname: parking?.reservationAvailable
            ? '/reservation'
            : '/subscription',
          query: {
            parking: parking.urlSlug,
            bookType: parking?.reservationAvailable
              ? 'reservation'
              : 'subscription',
            ...(parking?.reservationAvailable &&
              startDate && {
                startDate
              }),
            ...(parking?.reservationAvailable &&
              endDate && {
                endDate
              }),
            ...(!parking?.reservationAvailable && { startDate })
          }
        }}
        passHref
      >
        <TreriaryLink
          onClick={handleQuickBookClick}
          data-test-id="parking-tile-quick-book"
        >
          {translatedParkingTileQuickBook}
        </TreriaryLink>
      </Link>
    </PriceAndButton>
  )
}
